import {Directive, DoCheck, ElementRef, Input} from '@angular/core';
import {AbstractControl, FormControl} from "@angular/forms";

@Directive({
  selector: '[validateInput]'
})
export class ValidateInputDirective implements DoCheck {

  constructor( private elRef: ElementRef) {
  }

  @Input() control: AbstractControl;

  ngDoCheck() {
    if (this.control.valid) {
      this.elRef.nativeElement.child.findclassList.remove('has-error');
    } else {
      this.elRef.nativeElement.classList.add('has-error');
    }
  }

}
